import api from './api'

export default {
  userData () {
    return api.get('/user')
  }
}
